"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gutter = exports.WIDTH_ENUM = void 0;
const WIDTH_ENUM = {
  values: ["xSmall", "small", "medium", "large", "xLarge"],
  widths: {
    xSmall: 352,
    small: 480,
    medium: 664,
    large: 768,
    xLarge: 872
  },
  defaultValue: "medium"
};
exports.WIDTH_ENUM = WIDTH_ENUM;
const gutter = 60;
exports.gutter = gutter;
//# sourceMappingURL=shared-variables.js.map